/**
 * Polite announcements.
 *
 * docs/03 §10: incoming messages announce through a live region. Polite rather than
 * assertive — an arriving message must not interrupt an agent mid-sentence in the composer.
 */
export function LiveRegion({ message }: { message: string }) {
  return (
    <div aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  );
}
